
export const toggleMenu = () => {
    let isElement = document.querySelector(".categories-wrapper");

    let hasClassShowCategories = isElement.classList.contains("catetgories-slide");

    if(hasClassShowCategories) {
        isElement.classList.remove("catetgories-slide");
        return false;
    }

    isElement.classList.add("catetgories-slide");
}

export const checkShowMenu = () => {

    let isElement = document.querySelector(".main");
    let hasClassSlideShowing = isElement.classList.contains("slide-showing");
    let hasClassShowCategories = isElement.classList.contains("catetgories-slide");

    if(hasClassShowCategories) {
        isElement.classList.remove("catetgories-slide");
    }

    if(hasClassSlideShowing) {
        isElement.classList.remove("slide-showing");
        return false;
    }

    isElement.classList.add("slide-showing");
}

export const hideMenu = () => {
    let isElement = document.querySelector(".main");
    let hasClassSlideShowing = isElement.classList.contains("slide-showing");
    let hasClassShowCategories = isElement.classList.contains("catetgories-slide");

    if(hasClassShowCategories) {
        isElement.classList.remove("catetgories-slide");
    }

    if(hasClassSlideShowing) {
        isElement.classList.remove("slide-showing");
        return false;
    }
}




export const activeMenu = (idMenu) => {

    var classHome   = document.querySelector("#home");
    var classMovies    = document.querySelector("#movies");
    var classCategories    = document.querySelector("#categories");
    var classPornstars   = document.querySelector("#pornstars");

    var allClasses = [classHome, classMovies, classCategories, classPornstars];

    allClasses.forEach(function(el) {
        el.classList.remove("active");

    })

    let isElement = document.querySelector(idMenu);
    isElement.classList.add("active");
    return true;
    // let hasClassShowCategories = isElement.classList.contains("active");
    // console.log(hasClassShowCategories)
    // if(hasClassShowCategories) {
    //     return false;
    //
    // }
    //
    // isElement.setAttribute('aria-current','page');

}
